import { AnchorButton, Icon, PopoverPosition, Tooltip } from '@blueprintjs/core'
import React from 'react'
import { useSelector } from 'react-redux'
import config from '../config'
import Channels from '../constants/Channels'
import { AppState } from '../store'

const ExternalChannelLink = ({ channel, id, listingUrl = null, productId = null, showCustomLink = false }) => {
  const country = useSelector((s: AppState) => s.current.organization.address.country)
  if (!channel || !id) return null

  const isShopify = channel === Channels.SHOPIFY.name
  const isEbay = channel === Channels.EBAY.name
  const isShopgoodwill = channel === Channels.SHOPGOODWILL.name
  const isGoodwillFinds = channel === Channels.GOODWILLFINDS.name
  const isEtsy = channel === Channels.ETSY.name
  const isAmazon = channel === Channels.ETSY.name

  let href
  if (isShopify) {
    if (listingUrl === 'UNKNOWN') {
      if (productId) {
        href = `/products/${productId}` // See OrderItem.shopify_listing_url for explanation. This is the best we can do.
      } else {
        href = null
      }
    } else {
      href = listingUrl ? `//${listingUrl}` : null
    }
  } else if (isEbay) {
    const tld = country === 'CA' ? 'ca' : 'com'
    href = Channels.EBAY.itemLink(id, tld)
  } else if (isEtsy) {
    href = `${config.MARKET_URLS[channel] + id}`
  } else if (isGoodwillFinds) {
    href = `${config.MARKET_URLS[channel] + id}.html`
  } else if (isAmazon) {
    href = `${config.MARKET_URLS[channel] + id}`
  } else {
    href = config.MARKET_URLS[channel] + id
  }

  let linkText

  if (showCustomLink) {
    if (isEbay) {
      linkText = 'View in eBay'
    }
    if (isShopify) {
      linkText = 'View in Shopify'
    }
    if (isShopgoodwill) {
      linkText = 'View in Shopgoodwill'
    }
    if (isGoodwillFinds) {
      linkText = 'View in Goodwillfinds'
    }
    if (isEtsy) {
      linkText = 'View in Etsy'
    }
    if (isAmazon) {
      linkText = 'View in Amazon'
    }
  } else if (isShopify) {
    linkText = 'View on Shopify'

    if (listingUrl === 'UNKNOWN') {
      linkText = 'See product for link' // See OrderItem.shopify_listing_url for explanation
    }
  } else {
    linkText = id
  }

  return (
    <Tooltip
      content="Ended listings are not viewable on Shopify"
      disabled={href || !isShopify}
      position={PopoverPosition.BOTTOM}
    >
      <AnchorButton
        minimal
        small
        intent="primary"
        target="_blank"
        rel="noopener noreferrer"
        disabled={!href}
        href={href}
        className="bp3-button-as-link"
        rightIcon={!showCustomLink && <Icon iconSize={12} icon="share" />}
      >
        {linkText}
      </AnchorButton>
    </Tooltip>
  )
}

// workaround for Jest https://github.com/airbnb/enzyme/issues/1875

export { ExternalChannelLink }
export default React.memo(ExternalChannelLink)
